var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _g7, _path15, _path16, _g8, _path17, _path18, _g9, _path19, _path20, _g10, _path21, _path22, _g11, _path23, _path24, _g12, _path25, _path26, _g13, _path27, _path28, _g14, _path29, _path30, _g15, _path31, _path32, _g16, _path33, _path34, _g17, _path35, _path36, _g18, _path37, _path38, _g19, _path39, _path40, _g20, _path41, _path42, _g21, _path43, _path44, _g22, _path45, _path46, _g23, _path47, _path48, _g24, _path49, _path50, _g25, _path51, _path52, _g26, _path53, _path54, _g27, _path55, _path56, _g28, _path57, _path58, _g29, _path59, _path60, _g30, _path61, _path62, _g31, _path63, _path64, _g32, _path65, _path66, _g33, _path67, _path68, _g34, _path69, _path70, _g35, _path71, _path72, _g36, _path73, _path74, _g37, _path75, _path76, _g38, _path77, _path78, _g39, _path79, _path80, _g40, _path81, _path82, _g41, _path83, _path84, _g42, _path85, _path86, _g43, _path87, _path88, _g44, _path89, _path90, _g45, _path91, _path92, _g46, _path93, _path94, _g47, _path95, _path96, _g48, _path97, _path98, _g49, _path99, _path100, _g50, _path101, _path102, _g51, _path103, _path104, _g52, _path105, _path106, _g53, _path107, _path108, _g54, _path109, _path110, _g55, _path111, _path112, _g56, _path113, _path114, _g57, _path115, _path116, _g58, _path117, _path118, _g59, _path119, _path120, _g60, _path121, _path122, _g61, _path123, _path124, _g62, _path125, _path126, _g63, _path127, _path128, _g64, _path129, _path130, _g65, _path131, _path132, _g66, _path133, _path134, _g67, _path135, _path136, _g68, _path137, _path138, _g69, _path139, _path140, _g70, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _g71, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _g72, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _g73, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _g74, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _g75, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _g76;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagHighLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 680,
    viewBox: "0 0 375 680",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3002 288.31C1.52206 287.683 -0.251315 287.053 -2.02666 286.419C-1.85614 285.942 -1.6856 285.464 -1.51647 284.99C0.255509 285.623 2.03364 286.251 3.80702 286.88C3.6365 287.358 3.46933 287.837 3.3002 288.31Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 284,
    width: 7,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3002 288.31C1.52206 287.683 -0.251315 287.053 -2.02666 286.419C-1.85614 285.942 -1.6856 285.464 -1.51647 284.99C0.255509 285.623 2.03364 286.251 3.80702 286.88C3.6365 287.358 3.46933 287.837 3.3002 288.31Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.83828 286.612C-1.83828 286.612 -0.825484 286.433 -0.321077 285.294",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.555686 287.065C-0.555686 287.065 0.453721 286.885 0.958129 285.745",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.728982 287.523C0.728982 287.523 1.74317 287.341 2.24282 286.203",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.01146 287.977C2.01146 287.977 3.02228 287.793 3.52669 286.654",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63413 290.185C6.85796 289.562 5.07842 288.938 3.30168 288.307C3.47221 287.829 3.63938 287.351 3.8085 286.877C5.58328 287.503 7.35805 288.129 9.13759 288.754C8.97043 289.232 8.80325 289.711 8.63413 290.185Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 286,
    width: 7,
    height: 5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63413 290.185C6.85796 289.562 5.07842 288.938 3.30168 288.307C3.47221 287.829 3.63938 287.351 3.8085 286.877C5.58328 287.503 7.35805 288.129 9.13759 288.754C8.97043 289.232 8.80325 289.711 8.63413 290.185Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.48997 288.499C3.48997 288.499 4.5008 288.315 5.00184 287.175",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77599 288.954C4.77599 288.954 5.78679 288.77 6.28783 287.63",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06004 289.404C6.06004 289.404 7.07086 289.221 7.57191 288.08",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34258 289.857C7.34258 289.857 8.35339 289.674 8.85107 288.532",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9687 292.048C12.1912 291.429 10.4102 290.808 8.63406 290.185C8.80122 289.706 8.9684 289.227 9.13753 288.753C10.9137 289.376 12.6912 289.996 14.4688 290.615C14.3017 291.094 14.1345 291.573 13.9721 292.05L13.9687 292.048Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 288,
    width: 7,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9687 292.048C12.1912 291.429 10.4102 290.808 8.63406 290.185C8.80122 289.706 8.9684 289.227 9.13753 288.753C10.9137 289.376 12.6912 289.996 14.4688 290.615C14.3017 291.094 14.1345 291.573 13.9721 292.05L13.9687 292.048Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82366 290.374C8.82366 290.374 9.83587 290.187 10.3322 289.048",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1076 290.824C10.1076 290.824 11.1198 290.637 11.6175 289.495",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3917 291.274C11.3917 291.274 12.4005 291.085 12.8982 289.943",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6803 291.722C12.6803 291.722 13.6891 291.534 14.1868 290.392",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.309 293.899C17.5287 293.286 15.7463 292.668 13.9688 292.049C14.1359 291.57 14.3031 291.091 14.4655 290.615C16.243 291.234 18.0234 291.847 19.8024 292.463C19.6386 292.943 19.4728 293.419 19.309 293.899Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 290,
    width: 7,
    height: 4
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.309 293.899C17.5287 293.286 15.7463 292.668 13.9688 292.049C14.1359 291.57 14.3031 291.091 14.4655 290.615C16.243 291.234 18.0234 291.847 19.8024 292.463C19.6386 292.943 19.4728 293.419 19.309 293.899Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1586 292.238C14.1586 292.238 15.1674 292.049 15.6651 290.907",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4472 292.686C15.4472 292.686 16.456 292.497 16.9504 291.354",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.734 293.129C16.734 293.129 17.7428 292.941 18.2372 291.797",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0194 293.576C18.0194 293.576 19.0296 293.384 19.5239 292.241",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6529 295.73C22.8712 295.12 21.0894 294.511 19.3105 293.895C19.4743 293.415 19.64 292.939 19.8038 292.459C21.5842 293.072 23.3645 293.685 25.1429 294.293C24.9791 294.773 24.8167 295.25 24.6529 295.73Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 292,
    width: 7,
    height: 4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6529 295.73C22.8712 295.12 21.0894 294.511 19.3105 293.895C19.4743 293.415 19.64 292.939 19.8038 292.459C21.5842 293.072 23.3645 293.685 25.1429 294.293C24.9791 294.773 24.8167 295.25 24.6529 295.73Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4999 294.084C19.4999 294.084 20.5102 293.892 21.0011 292.747",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7867 294.527C20.7867 294.527 21.7969 294.335 22.2879 293.191",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0735 294.971C22.0735 294.971 23.0804 294.777 23.5748 293.634",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3617 295.411C23.3617 295.411 24.3719 295.219 24.8629 294.074",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0043 297.553C28.2212 296.947 26.438 296.341 24.6563 295.732C24.8201 295.252 24.9825 294.775 25.1463 294.295C26.928 294.904 28.7078 295.509 30.491 296.115C30.3272 296.595 30.1681 297.073 30.0043 297.553Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 294,
    width: 7,
    height: 4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0043 297.553C28.2212 296.947 26.438 296.341 24.6563 295.732C24.8201 295.252 24.9825 294.775 25.1463 294.295C26.928 294.904 28.7078 295.509 30.491 296.115C30.3272 296.595 30.1681 297.073 30.0043 297.553Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8458 295.921C24.8458 295.921 25.856 295.729 26.3436 294.583",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.134 296.36C26.134 296.36 27.1409 296.167 27.6319 295.022",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4235 296.797C27.4235 296.797 28.4318 296.601 28.9228 295.456",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7117 297.238C28.7117 297.238 29.72 297.041 30.2076 295.895",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3559 299.357C33.57 298.757 31.7854 298.155 30.0023 297.548C30.166 297.068 30.3251 296.59 30.4889 296.11C32.2721 296.716 34.0546 297.314 35.8392 297.917C35.6787 298.398 35.5163 298.875 35.3559 299.357Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 296,
    width: 6,
    height: 4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3559 299.357C33.57 298.757 31.7854 298.155 30.0023 297.548C30.166 297.068 30.3251 296.59 30.4889 296.11C32.2721 296.716 34.0546 297.314 35.8392 297.917C35.6787 298.398 35.5163 298.875 35.3559 299.357Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1951 297.74C30.1951 297.74 31.2034 297.543 31.691 296.397",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4848 298.176C31.4848 298.176 32.4931 297.979 32.9807 296.833",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7743 298.613C32.7743 298.613 33.7826 298.416 34.2668 297.268",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0653 299.046C34.0653 299.046 35.0736 298.85 35.5578 297.702",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7152 301.15C38.9278 300.555 37.1438 299.96 35.3593 299.357C35.5197 298.876 35.6821 298.399 35.8426 297.917C37.6252 298.515 39.4111 299.115 41.1951 299.709C41.0346 300.191 40.8756 300.669 40.7152 301.15Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 297,
    width: 7,
    height: 5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7152 301.15C38.9278 300.555 37.1438 299.96 35.3593 299.357C35.5197 298.876 35.6821 298.399 35.8426 297.917C37.6252 298.515 39.4111 299.115 41.1951 299.709C41.0346 300.191 40.8756 300.669 40.7152 301.15Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.549 299.547C35.549 299.547 36.5573 299.35 37.0429 298.199",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8399 299.98C36.8399 299.98 37.8462 299.779 38.3305 298.631",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1323 300.41C38.1323 300.41 39.1386 300.209 39.6229 299.061",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4199 300.842C39.4199 300.842 40.4262 300.64 40.9105 299.493",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0766 302.931C44.2879 302.339 42.5025 301.747 40.7152 301.151C40.8756 300.67 41.0346 300.192 41.1951 299.71C42.979 300.305 44.7678 300.897 46.5531 301.489C46.3927 301.97 46.237 302.45 46.0766 302.931Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 299,
    width: 7,
    height: 4
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0766 302.931C44.2879 302.339 42.5025 301.747 40.7152 301.151C40.8756 300.67 41.0346 300.192 41.1951 299.71C42.979 300.305 44.7678 300.897 46.5531 301.489C46.3927 301.97 46.237 302.45 46.0766 302.931Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.906 301.337C40.906 301.337 41.9123 301.135 42.3932 299.986",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1985 301.766C42.1985 301.766 43.2048 301.565 43.6857 300.416",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4908 302.196C43.4908 302.196 44.4971 301.995 44.978 300.846",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7812 302.621C44.7812 302.621 45.7889 302.417 46.2664 301.266",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4416 304.692C49.6535 304.107 47.8633 303.518 46.0779 302.927C46.2384 302.445 46.394 301.966 46.5545 301.484C48.3399 302.076 50.128 302.66 51.9148 303.248C51.7577 303.731 51.5987 304.209 51.4416 304.692Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 301,
    width: 6,
    height: 4
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4416 304.692C49.6535 304.107 47.8633 303.518 46.0779 302.927C46.2384 302.445 46.394 301.966 46.5545 301.484C48.3399 302.076 50.128 302.66 51.9148 303.248C51.7577 303.731 51.5987 304.209 51.4416 304.692Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.269 303.113C46.269 303.113 47.2767 302.908 47.7542 301.757",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5628 303.539C47.5628 303.539 48.5705 303.335 49.048 302.184",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8532 303.964C48.8532 303.964 49.8609 303.759 50.335 302.608",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1469 304.391C50.1469 304.391 51.1546 304.186 51.6287 303.034",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.811 306.444C55.0214 305.863 53.2285 305.281 51.4417 304.693C51.5988 304.21 51.7578 303.732 51.9149 303.249C53.703 303.833 55.4912 304.418 57.2808 304.999C57.1237 305.482 56.968 305.961 56.811 306.444Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 303,
    width: 7,
    height: 4
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.811 306.444C55.0214 305.863 53.2285 305.281 51.4417 304.693C51.5988 304.21 51.7578 303.732 51.9149 303.249C53.703 303.833 55.4912 304.418 57.2808 304.999C57.1237 305.482 56.968 305.961 56.811 306.444Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6359 304.88C51.6359 304.88 52.6403 304.674 53.1178 303.524",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9278 305.301C52.9278 305.301 53.9335 305.091 54.4062 303.943",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.223 305.724C54.223 305.724 55.2287 305.515 55.7029 304.363",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5161 306.143C55.5161 306.143 56.5219 305.934 56.996 304.782",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1872 308.178C60.3962 307.6 58.6053 307.023 56.8123 306.44C56.9694 305.957 57.1251 305.478 57.2821 304.995C59.0717 305.576 60.8627 306.154 62.6536 306.731C62.4966 307.214 62.3442 307.695 62.1872 308.178Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 304,
    width: 7,
    height: 5
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1872 308.178C60.3962 307.6 58.6053 307.023 56.8123 306.44C56.9694 305.957 57.1251 305.478 57.2821 304.995C59.0717 305.576 60.8627 306.154 62.6536 306.731C62.4966 307.214 62.3442 307.695 62.1872 308.178Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0068 306.628C57.0068 306.628 58.0125 306.418 58.4833 305.265",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3 307.047C58.3 307.047 59.3057 306.837 59.7765 305.684",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5966 307.466C59.5966 307.466 60.6023 307.257 61.0731 306.104",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8897 307.884C60.8897 307.884 61.8955 307.675 62.3629 306.52",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5643 309.902C65.7705 309.331 63.9782 308.756 62.1872 308.179C62.3443 307.696 62.4966 307.215 62.6537 306.732C64.4447 307.31 66.235 307.879 68.0274 308.454C67.8737 308.938 67.7214 309.419 67.5643 309.902Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 306,
    width: 7,
    height: 4
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5643 309.902C65.7705 309.331 63.9782 308.756 62.1872 308.179C62.3443 307.696 62.4966 307.215 62.6537 306.732C64.4447 307.31 66.235 307.879 68.0274 308.454C67.8737 308.938 67.7214 309.419 67.5643 309.902Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3818 308.366C62.3818 308.366 63.3889 308.153 63.8563 306.999",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6763 308.781C63.6763 308.781 64.6801 308.567 65.1508 307.414",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9709 309.196C64.9709 309.196 65.9747 308.982 66.4421 307.828",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2668 309.608C66.2668 309.608 67.2706 309.393 67.738 308.239",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9469 311.611C71.1518 311.043 69.3566 310.476 67.5643 309.901C67.718 309.417 67.8703 308.936 68.0274 308.453C69.8211 309.024 71.6115 309.594 73.4067 310.162C73.2544 310.643 73.1006 311.127 72.9483 311.608L72.9469 311.611Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 308,
    width: 7,
    height: 4
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9469 311.611C71.1518 311.043 69.3566 310.476 67.5643 309.901C67.718 309.417 67.8703 308.936 68.0274 308.453C69.8211 309.024 71.6115 309.594 73.4067 310.162C73.2544 310.643 73.1006 311.127 72.9483 311.608L72.9469 311.611Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.76 310.085C67.76 310.085 68.7638 309.871 69.2312 308.716",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.056 310.497C69.056 310.497 70.0597 310.283 70.5238 309.127",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3519 310.908C70.3519 310.908 71.3557 310.694 71.8197 309.538",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6479 311.321C71.6479 311.321 72.6531 311.103 73.1171 309.947",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3332 313.303C76.5366 312.739 74.7434 312.176 72.9483 311.608C73.1006 311.127 73.2543 310.643 73.4066 310.162C75.1984 310.728 76.9949 311.293 78.7881 311.855C78.6392 312.338 78.4855 312.822 78.3332 313.303Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 310,
    width: 7,
    height: 4
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3332 313.303C76.5366 312.739 74.7434 312.176 72.9483 311.608C73.1006 311.127 73.2543 310.643 73.4066 310.162C75.1984 310.728 76.9949 311.293 78.7881 311.855C78.6392 312.338 78.4855 312.822 78.3332 313.303Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1428 311.795C73.1428 311.795 74.1479 311.578 74.6086 310.42",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4401 312.204C74.4401 312.204 75.4419 311.985 75.906 310.829",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7375 312.612C75.7375 312.612 76.7393 312.393 77.2033 311.237",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0348 313.02C77.0348 313.02 78.0366 312.801 78.4973 311.644",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7202 314.983C81.9242 314.427 80.1263 313.866 78.3297 313.302C78.4787 312.819 78.6324 312.335 78.7847 311.854C80.5779 312.417 82.3758 312.978 84.1718 313.534C84.0228 314.017 83.8725 314.502 83.7236 314.985L83.7202 314.983Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 311,
    width: 7,
    height: 4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7202 314.983C81.9242 314.427 80.1263 313.866 78.3297 313.302C78.4787 312.819 78.6324 312.335 78.7847 311.854C80.5779 312.417 82.3758 312.978 84.1718 313.534C84.0228 314.017 83.8725 314.502 83.7236 314.985L83.7202 314.983Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.5289 313.487C78.5289 313.487 79.5307 313.268 79.9913 312.11",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8277 313.892C79.8277 313.892 80.831 313.67 81.2902 312.516",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1265 314.297C81.1265 314.297 82.1297 314.074 82.587 312.916",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4219 314.7C82.4219 314.7 83.4251 314.478 83.8824 313.319",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1163 316.651C87.3189 316.098 85.5182 315.544 83.7236 314.984C83.8725 314.502 84.0229 314.016 84.1718 313.534C85.9678 314.09 87.7638 314.646 89.5611 315.199C89.4122 315.681 89.2618 316.167 89.1163 316.651Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 313,
    width: 7,
    height: 4
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1163 316.651C87.3189 316.098 85.5182 315.544 83.7236 314.984C83.8725 314.502 84.0229 314.016 84.1718 313.534C85.9678 314.09 87.7638 314.646 89.5611 315.199C89.4122 315.681 89.2618 316.167 89.1163 316.651Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.9194 315.168C83.9194 315.168 84.9226 314.946 85.3799 313.787",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2162 315.568C85.2162 315.568 86.2195 315.346 86.6734 314.186",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5164 315.97C86.5164 315.97 87.5196 315.747 87.9736 314.587",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8165 316.371C87.8165 316.371 88.8197 316.149 89.2737 314.989",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5125 318.299C92.7137 317.75 90.9149 317.201 89.1142 316.646C89.2631 316.164 89.4135 315.678 89.5591 315.195C91.3564 315.747 93.1552 316.297 94.954 316.846C94.8084 317.33 94.658 317.816 94.5125 318.299Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 315,
    width: 6,
    height: 4
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5125 318.299C92.7137 317.75 90.9149 317.201 89.1142 316.646C89.2631 316.164 89.4135 315.678 89.5591 315.195C91.3564 315.747 93.1552 316.297 94.954 316.846C94.8084 317.33 94.658 317.816 94.5125 318.299Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3134 316.831C89.3134 316.831 90.3146 316.604 90.7672 315.447",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6149 317.23C90.6149 317.23 91.6162 317.003 92.0701 315.843",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9117 317.63C91.9117 317.63 92.913 317.403 93.3669 316.243",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2147 318.025C93.2147 318.025 94.2159 317.798 94.6665 316.636",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9164 319.939C98.1148 319.396 96.3147 318.85 94.5159 318.301C94.6615 317.817 94.8118 317.331 94.9574 316.848C96.7562 317.397 98.5563 317.943 100.355 318.485C100.209 318.968 100.062 319.455 99.9164 319.939Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 316,
    width: 7,
    height: 4
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9164 319.939C98.1148 319.396 96.3147 318.85 94.5159 318.301C94.6615 317.817 94.8118 317.331 94.9574 316.848C96.7562 317.397 98.5563 317.943 100.355 318.485C100.209 318.968 100.062 319.455 99.9164 319.939Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.7116 318.485C94.7116 318.485 95.7128 318.258 96.1634 317.096",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0112 318.878C96.0112 318.878 97.0124 318.651 97.463 317.49",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3143 319.274C97.3143 319.274 98.3155 319.047 98.7627 317.884",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6139 319.667C98.6139 319.667 99.6131 319.436 100.062 318.277",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M105.319 321.563C103.516 321.023 101.713 320.484 99.913 319.938C100.059 319.454 100.206 318.967 100.351 318.483C102.153 319.026 103.951 319.567 105.754 320.107C105.608 320.59 105.465 321.079 105.319 321.563Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 318,
    width: 7,
    height: 4
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M105.319 321.563C103.516 321.023 101.713 320.484 99.913 319.938C100.059 319.454 100.206 318.967 100.351 318.483C102.153 319.026 103.951 319.567 105.754 320.107C105.608 320.59 105.465 321.079 105.319 321.563Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.114 320.119C100.114 320.119 101.113 319.887 101.563 318.726",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.413 320.513C101.413 320.513 102.412 320.281 102.86 319.118",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.718 320.904C102.718 320.904 103.717 320.672 104.164 319.509",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.019 321.295C104.019 321.295 105.018 321.063 105.465 319.9",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M110.731 323.174C108.926 322.638 107.125 322.103 105.323 321.564C105.468 321.08 105.612 320.592 105.757 320.108C107.557 320.646 109.361 321.182 111.162 321.717C111.02 322.202 110.874 322.685 110.731 323.174Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 320,
    width: 7,
    height: 4
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M110.731 323.174C108.926 322.638 107.125 322.103 105.323 321.564C105.468 321.08 105.612 320.592 105.757 320.108C107.557 320.646 109.361 321.182 111.162 321.717C111.02 322.202 110.874 322.685 110.731 323.174Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.52 321.745C105.52 321.745 106.519 321.513 106.963 320.349",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.822 322.132C106.822 322.132 107.821 321.9 108.265 320.735",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.124 322.518C108.124 322.518 109.125 322.283 109.567 321.122",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43 322.907C109.43 322.907 110.431 322.671 110.871 321.506",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M116.143 324.765C114.339 324.237 112.533 323.705 110.729 323.169C110.871 322.684 111.017 322.2 111.16 321.711C112.961 322.246 114.767 322.779 116.571 323.306C116.428 323.792 116.286 324.277 116.143 324.765Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 321,
    width: 7,
    height: 4
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M116.143 324.765C114.339 324.237 112.533 323.705 110.729 323.169C110.871 322.684 111.017 322.2 111.16 321.711C112.961 322.246 114.767 322.779 116.571 323.306C116.428 323.792 116.286 324.277 116.143 324.765Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.929 323.351C110.929 323.351 111.93 323.116 112.37 321.95",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.232 323.738C112.232 323.738 113.229 323.501 113.673 322.337",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.535 324.121C113.535 324.121 114.533 323.885 114.973 322.719",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.843 324.506C114.843 324.506 115.84 324.27 116.28 323.104",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M121.559 326.347C119.754 325.823 117.946 325.293 116.143 324.766C116.285 324.28 116.427 323.795 116.571 323.307C118.375 323.835 120.178 324.363 121.983 324.887C121.841 325.372 121.702 325.859 121.56 326.344L121.559 326.347Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 323,
    width: 6,
    height: 4
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M121.559 326.347C119.754 325.823 117.946 325.293 116.143 324.766C116.285 324.28 116.427 323.795 116.571 323.307C118.375 323.835 120.178 324.363 121.983 324.887C121.841 325.372 121.702 325.859 121.56 326.344L121.559 326.347Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.343 324.948C116.343 324.948 117.341 324.711 117.781 323.545",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.648 325.327C117.648 325.327 118.647 325.087 119.083 323.924",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.952 325.711C118.952 325.711 119.951 325.471 120.388 324.304",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.257 326.091C120.257 326.091 121.256 325.851 121.693 324.683",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M126.98 327.916C125.174 327.395 123.367 326.873 121.559 326.347C121.701 325.862 121.84 325.376 121.982 324.891C123.787 325.415 125.594 325.936 127.4 326.458C127.262 326.944 127.119 327.429 126.98 327.916Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 324,
    width: 7,
    height: 4
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M126.981 327.916C125.174 327.395 123.368 326.873 121.559 326.347C121.701 325.862 121.84 325.376 121.982 324.891C123.787 325.415 125.594 325.936 127.4 326.458C127.262 326.944 127.119 327.429 126.981 327.916Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.761 326.525C121.761 326.525 122.759 326.285 123.193 325.117",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.066 326.905C123.066 326.905 124.065 326.665 124.498 325.496",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.372 327.282C124.372 327.282 125.368 327.041 125.805 325.873",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.678 327.662C125.678 327.662 126.676 327.422 127.107 326.252",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M132.404 329.47C130.595 328.955 128.787 328.437 126.981 327.916C127.119 327.429 127.262 326.944 127.4 326.458C129.207 326.979 131.011 327.495 132.821 328.01C132.682 328.496 132.543 328.983 132.404 329.47Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 326,
    width: 7,
    height: 4
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M132.404 329.469C130.595 328.955 128.787 328.437 126.981 327.916C127.119 327.429 127.262 326.944 127.4 326.458C129.207 326.979 131.012 327.495 132.821 328.01C132.682 328.496 132.543 328.983 132.404 329.469Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.182 328.095C127.182 328.095 128.179 327.85 128.611 326.685",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.489 328.472C128.489 328.472 129.486 328.227 129.919 327.059",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.793 328.844C129.793 328.844 130.79 328.599 131.22 327.429",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.101 329.217C131.101 329.217 132.098 328.972 132.528 327.802",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M137.834 331.009C136.023 330.498 134.214 329.983 132.404 329.469C132.543 328.982 132.682 328.496 132.821 328.009C134.63 328.524 136.436 329.037 138.244 329.547C138.105 330.033 137.969 330.521 137.83 331.008L137.834 331.009Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 328,
    width: 7,
    height: 4
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M137.834 331.009C136.023 330.498 134.214 329.983 132.404 329.469C132.543 328.982 132.682 328.496 132.821 328.009C134.63 328.524 136.436 329.037 138.244 329.547C138.105 330.033 137.969 330.521 137.831 331.008L137.834 331.009Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.606 329.647C132.606 329.647 133.603 329.402 134.033 328.232",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.916 330.017C133.916 330.017 134.912 329.772 135.339 328.601",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22 330.389C135.22 330.389 136.214 330.143 136.644 328.973",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.53 330.759C136.53 330.759 137.524 330.509 137.953 329.343",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M143.265 332.534C141.453 332.027 139.645 331.52 137.834 331.009C137.973 330.523 138.108 330.035 138.247 329.548C140.054 330.058 141.866 330.566 143.675 331.072C143.54 331.56 143.404 332.048 143.265 332.534Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 137,
    y: 329,
    width: 7,
    height: 4
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M143.266 332.534C141.453 332.027 139.645 331.52 137.834 331.009C137.973 330.522 138.108 330.035 138.247 329.548C140.054 330.058 141.867 330.566 143.675 331.072C143.54 331.56 143.404 332.048 143.266 332.534Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.037 331.185C138.037 331.185 139.032 330.935 139.457 329.767",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.343 331.553C139.343 331.553 140.338 331.304 140.765 330.132",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.653 331.923C140.653 331.923 141.647 331.673 142.074 330.502",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.96 332.288C141.96 332.288 142.955 332.038 143.378 330.865",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M148.699 334.044C146.888 333.545 145.074 333.04 143.266 332.534C143.401 332.046 143.536 331.558 143.675 331.071C145.484 331.578 147.294 332.081 149.106 332.58C148.97 333.068 148.835 333.556 148.699 334.044Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 331,
    width: 7,
    height: 4
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M148.699 334.044C146.888 333.544 145.074 333.04 143.266 332.534C143.401 332.046 143.536 331.558 143.675 331.071C145.484 331.578 147.294 332.081 149.106 332.58C148.97 333.068 148.835 333.556 148.699 334.044Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.469 332.709C143.469 332.709 144.463 332.459 144.887 331.286",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.776 333.075C144.776 333.075 145.772 332.822 146.194 331.653",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.083 333.44C146.083 333.44 147.08 333.187 147.498 332.016",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.396 333.803C147.396 333.803 148.392 333.55 148.811 332.38",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M154.14 335.538C152.327 335.041 150.516 334.542 148.701 334.041C148.837 333.553 148.972 333.065 149.107 332.577C150.919 333.077 152.731 333.576 154.543 334.073C154.408 334.56 154.276 335.05 154.14 335.538Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 332,
    width: 7,
    height: 4
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M154.141 335.538C152.328 335.041 150.516 334.542 148.701 334.041C148.837 333.553 148.972 333.065 149.107 332.577C150.919 333.077 152.731 333.576 154.544 334.073C154.408 334.561 154.276 335.05 154.141 335.538Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.903 334.219C148.903 334.219 149.896 333.965 150.319 332.792",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.212 334.58C150.212 334.58 151.208 334.327 151.625 333.152",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.522 334.939C151.522 334.939 152.515 334.684 152.935 333.51",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.834 335.302C152.834 335.302 153.827 335.048 154.247 333.873",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M159.581 337.023C157.766 336.53 155.952 336.037 154.139 335.541C154.274 335.053 154.407 334.564 154.542 334.076C156.355 334.572 158.169 335.065 159.98 335.556C159.848 336.046 159.716 336.535 159.584 337.025L159.581 337.023Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 154,
    y: 334,
    width: 6,
    height: 4
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M159.581 337.023C157.766 336.53 155.952 336.037 154.139 335.541C154.274 335.053 154.407 334.564 154.542 334.076C156.355 334.572 158.169 335.065 159.98 335.557C159.848 336.046 159.716 336.535 159.584 337.024L159.581 337.023Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.342 335.717C154.342 335.717 155.336 335.459 155.752 334.287",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.652 336.075C155.652 336.075 156.646 335.818 157.062 334.645",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.964 336.43C156.964 336.43 157.958 336.172 158.374 335",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.274 336.789C158.274 336.789 159.268 336.531 159.682 335.354",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M165.028 338.492C163.211 338.006 161.395 337.516 159.581 337.023C159.713 336.534 159.845 336.044 159.977 335.555C161.791 336.048 163.604 336.536 165.421 337.022C165.289 337.512 165.157 338.001 165.029 338.488L165.028 338.492Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 335,
    width: 7,
    height: 4
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M165.028 338.492C163.211 338.005 161.395 337.516 159.581 337.023C159.713 336.534 159.845 336.044 159.977 335.555C161.791 336.048 163.604 336.536 165.421 337.022C165.289 337.512 165.157 338.001 165.029 338.488L165.028 338.492Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.784 337.198C159.784 337.198 160.778 336.94 161.192 335.763",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.095 337.553C161.095 337.553 162.09 337.296 162.503 336.119",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.408 337.905C162.408 337.905 163.399 337.646 163.813 336.469",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.72 338.26C163.72 338.26 164.712 337.998 165.124 336.824",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M170.477 339.945C168.659 339.463 166.845 338.978 165.028 338.492C165.16 338.002 165.292 337.513 165.42 337.026C167.233 337.51 169.05 337.997 170.866 338.478C170.737 338.969 170.605 339.458 170.477 339.945Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 337,
    width: 6,
    height: 3
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M170.478 339.945C168.659 339.463 166.845 338.978 165.028 338.491C165.16 338.002 165.292 337.513 165.42 337.025C167.233 337.51 169.05 337.997 170.866 338.478C170.737 338.969 170.605 339.458 170.478 339.945Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.233 338.664C165.233 338.664 166.225 338.401 166.637 337.228",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.545 339.015C166.545 339.015 167.538 338.753 167.947 337.578",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.855 339.366C167.855 339.366 168.847 339.103 169.256 337.928",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.168 339.717C169.168 339.717 170.157 339.453 170.57 338.276",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M175.929 341.384C174.113 340.906 172.293 340.426 170.478 339.945C170.606 339.454 170.738 338.965 170.866 338.477C172.681 338.959 174.496 339.44 176.314 339.915C176.185 340.406 176.058 340.893 175.929 341.384Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 338,
    width: 7,
    height: 4
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M175.929 341.384C174.113 340.906 172.293 340.426 170.478 339.945C170.606 339.454 170.738 338.965 170.866 338.477C172.681 338.959 174.496 339.44 176.314 339.915C176.185 340.406 176.058 340.893 175.929 341.384Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.682 340.117C170.682 340.117 171.674 339.855 172.081 338.675",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.996 340.466C171.996 340.466 172.989 340.203 173.396 339.024",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.307 340.813C173.307 340.813 174.298 340.545 174.707 339.37",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.622 341.161C174.622 341.161 175.612 340.894 176.018 339.718",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M181.386 342.809C179.567 342.338 177.749 341.863 175.929 341.384C176.058 340.893 176.185 340.405 176.314 339.915C178.131 340.393 179.949 340.868 181.768 341.339C181.639 341.83 181.515 342.318 181.386 342.809Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 339,
    width: 7,
    height: 4
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M181.387 342.809C179.567 342.338 177.749 341.863 175.929 341.383C176.058 340.893 176.185 340.405 176.314 339.915C178.131 340.393 179.949 340.868 181.768 341.339C181.639 341.83 181.515 342.318 181.387 342.809Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.134 341.556C176.134 341.556 177.124 341.288 177.53 340.112",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.45 341.9C177.45 341.9 178.44 341.633 178.845 340.457",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.762 342.244C178.762 342.244 179.752 341.977 180.154 340.799",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.078 342.589C180.078 342.589 181.068 342.322 181.472 341.141",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M186.846 344.219C185.025 343.751 183.206 343.28 181.387 342.809C181.515 342.318 181.639 341.829 181.768 341.338C183.588 341.81 185.407 342.281 187.224 342.748C187.099 343.24 186.972 343.727 186.846 344.219Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 341,
    width: 7,
    height: 4
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M186.846 344.219C185.026 343.751 183.206 343.28 181.387 342.808C181.515 342.318 181.639 341.829 181.768 341.338C183.588 341.81 185.407 342.281 187.224 342.748C187.099 343.24 186.972 343.727 186.846 344.219Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.591 342.98C181.591 342.98 182.582 342.713 182.985 341.532",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.908 343.322C182.908 343.322 183.897 343.05 184.299 341.872",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.222 343.663C184.222 343.663 185.211 343.391 185.613 342.213",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.536 344.002C185.536 344.002 186.524 343.73 186.926 342.553",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M192.311 345.616C190.489 345.152 188.667 344.687 186.846 344.219C186.972 343.727 187.099 343.239 187.224 342.747C189.045 343.215 190.863 343.682 192.683 344.142C192.557 344.634 192.433 345.123 192.308 345.615L192.311 345.616Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 342,
    width: 7,
    height: 4
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M192.311 345.616C190.489 345.151 188.667 344.687 186.846 344.219C186.972 343.727 187.099 343.239 187.224 342.747C189.045 343.215 190.863 343.682 192.683 344.142C192.557 344.634 192.433 345.123 192.308 345.615L192.311 345.616Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.051 344.39C187.051 344.39 188.039 344.118 188.438 342.939",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.368 344.732C188.368 344.732 189.356 344.46 189.755 343.281",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.685 345.065C189.685 345.065 190.673 344.793 191.073 343.611",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 345.402C191 345.402 191.988 345.13 192.385 343.946",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M197.777 347.002C195.956 346.545 194.133 346.081 192.31 345.62C192.435 345.127 192.559 344.639 192.685 344.147C194.503 344.61 196.327 345.071 198.149 345.527C198.023 346.02 197.903 346.51 197.777 347.002Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 192,
    y: 344,
    width: 7,
    height: 4
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M197.777 347.002C195.956 346.545 194.134 346.081 192.31 345.619C192.435 345.127 192.559 344.639 192.685 344.146C194.503 344.61 196.327 345.071 198.149 345.528C198.023 346.02 197.903 346.51 197.777 347.002Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.516 345.788C192.516 345.788 193.506 345.513 193.901 344.332",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.831 346.125C193.831 346.125 194.821 345.85 195.216 344.669",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.148 346.458C195.148 346.458 196.137 346.183 196.529 345.001",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.466 346.789C196.466 346.789 197.452 346.512 197.847 345.332",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M203.247 348.37C201.424 347.917 199.599 347.459 197.777 347.002C197.903 346.51 198.023 346.02 198.149 345.528C199.97 345.984 201.792 346.441 203.613 346.897C203.493 347.387 203.367 347.879 203.247 348.37Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 345,
    width: 7,
    height: 4
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M203.247 348.37C201.424 347.916 199.599 347.459 197.777 347.002C197.903 346.51 198.023 346.02 198.149 345.528C199.97 345.984 201.792 346.441 203.614 346.897C203.493 347.387 203.368 347.879 203.247 348.37Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.982 347.174C197.982 347.174 198.968 346.897 199.364 345.716",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 347.504C199.3 347.504 200.286 347.227 200.678 346.045",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.618 347.833C200.618 347.833 201.604 347.557 201.998 346.371",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.936 348.164C201.936 348.164 202.924 347.884 203.316 346.702",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M208.721 349.726C206.896 349.276 205.072 348.827 203.246 348.372C203.366 347.882 203.492 347.39 203.612 346.9C205.435 347.353 207.258 347.806 209.082 348.256C208.962 348.746 208.84 349.239 208.719 349.729L208.721 349.726Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 203,
    y: 346,
    width: 7,
    height: 4
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M208.721 349.726C206.896 349.276 205.072 348.826 203.246 348.372C203.366 347.882 203.492 347.39 203.612 346.899C205.435 347.353 207.258 347.806 209.082 348.256C208.962 348.746 208.84 349.239 208.719 349.729L208.721 349.726Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.452 348.54C203.452 348.54 204.439 348.26 204.828 347.077",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.771 348.867C204.771 348.867 205.759 348.586 206.147 347.403",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.09 349.194C206.09 349.194 207.078 348.914 207.467 347.73",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.41 349.521C207.41 349.521 208.398 349.241 208.783 348.056",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M214.198 351.065C212.372 350.619 210.546 350.172 208.721 349.726C208.841 349.236 208.963 348.742 209.084 348.252C210.908 348.702 212.731 349.147 214.556 349.593C214.436 350.083 214.317 350.578 214.196 351.068L214.198 351.065Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 208,
    y: 348,
    width: 7,
    height: 4
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M214.198 351.065C212.372 350.618 210.546 350.172 208.721 349.726C208.841 349.235 208.963 348.742 209.084 348.252C210.908 348.702 212.731 349.147 214.556 349.593C214.436 350.083 214.317 350.578 214.197 351.068L214.198 351.065Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.927 349.895C208.927 349.895 209.911 349.613 210.299 348.43",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.247 350.218C210.247 350.218 211.232 349.937 211.62 348.753",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.563 350.544C211.563 350.544 212.549 350.259 212.934 349.074",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.885 350.863C212.885 350.863 213.871 350.578 214.256 349.394",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M219.676 352.393C217.848 351.953 216.024 351.511 214.198 351.065C214.319 350.575 214.437 350.08 214.558 349.59C216.384 350.036 218.209 350.474 220.033 350.916C219.916 351.407 219.797 351.902 219.676 352.393Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 214,
    y: 349,
    width: 7,
    height: 4
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M219.676 352.393C217.848 351.953 216.024 351.511 214.198 351.065C214.319 350.575 214.437 350.08 214.558 349.589C216.384 350.036 218.209 350.474 220.033 350.916C219.916 351.407 219.797 351.902 219.676 352.393Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.404 351.233C214.404 351.233 215.39 350.948 215.775 349.764",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.725 351.556C215.725 351.556 216.711 351.272 217.093 350.085",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.044 351.876C217.044 351.876 218.026 351.59 218.411 350.405",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.363 352.194C218.363 352.194 219.348 351.909 219.73 350.723",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M225.158 353.703C223.331 353.268 221.502 352.831 219.674 352.388C219.792 351.897 219.91 351.402 220.031 350.912C221.856 351.35 223.681 351.788 225.511 352.224C225.394 352.716 225.277 353.208 225.158 353.703Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 219,
    y: 350,
    width: 7,
    height: 4
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M225.158 353.702C223.332 353.268 221.502 352.831 219.674 352.388C219.792 351.897 219.91 351.402 220.031 350.912C221.856 351.35 223.681 351.788 225.511 352.225C225.394 352.716 225.277 353.208 225.158 353.702Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.882 352.561C219.882 352.561 220.868 352.276 221.247 351.089",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.206 352.878C221.206 352.878 222.19 352.588 222.57 351.405",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.526 353.194C222.526 353.194 223.51 352.904 223.892 351.718",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.846 353.509C223.846 353.509 224.83 353.219 225.209 352.032",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M230.644 355.001C228.816 354.57 226.985 354.137 225.158 353.702C225.275 353.21 225.393 352.719 225.511 352.224C227.338 352.659 229.166 353.09 230.994 353.522C230.877 354.013 230.763 354.506 230.644 355.001Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 352,
    width: 6,
    height: 4
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M230.644 355.001C228.816 354.57 226.985 354.137 225.158 353.702C225.275 353.21 225.393 352.719 225.511 352.224C227.338 352.659 229.166 353.09 230.994 353.522C230.877 354.013 230.763 354.506 230.644 355.001Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.367 353.872C225.367 353.872 226.351 353.583 226.73 352.395",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.688 354.188C226.688 354.188 227.671 353.898 228.05 352.711",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.009 354.499C228.009 354.499 228.993 354.21 229.368 353.021",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.331 354.811C229.331 354.811 230.315 354.521 230.69 353.332",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M236.137 356.284C234.306 355.859 232.477 355.431 230.649 354.999C230.766 354.507 230.88 354.014 230.999 353.52C232.827 353.951 234.656 354.379 236.483 354.803C236.37 355.296 236.256 355.789 236.142 356.282L236.137 356.284Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 230,
    y: 353,
    width: 7,
    height: 4
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M236.137 356.284C234.306 355.859 232.477 355.43 230.649 354.999C230.766 354.507 230.88 354.014 230.999 353.52C232.827 353.951 234.656 354.379 236.484 354.803C236.37 355.296 236.256 355.789 236.142 356.282L236.137 356.284Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.853 355.171C230.853 355.171 231.835 354.877 232.212 353.693",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.176 355.48C232.176 355.48 233.162 355.187 233.532 354",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.499 355.788C233.499 355.788 234.481 355.493 234.856 354.304",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.822 356.096C234.822 356.096 235.804 355.802 236.179 354.613",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M241.627 357.554C239.795 357.132 237.965 356.707 236.134 356.282C236.248 355.789 236.362 355.296 236.476 354.804C238.306 355.228 240.134 355.652 241.962 356.072C241.849 356.565 241.735 357.058 241.624 357.552L241.627 357.554Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 236,
    y: 354,
    width: 6,
    height: 4
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M241.628 357.553C239.795 357.132 237.965 356.707 236.134 356.282C236.248 355.789 236.362 355.296 236.476 354.803C238.306 355.228 240.134 355.652 241.963 356.072C241.849 356.565 241.735 357.058 241.624 357.552L241.628 357.553Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.343 356.452C236.343 356.452 237.325 356.157 237.697 354.967",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.666 356.76C237.666 356.76 238.648 356.466 239.02 355.276",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.991 357.066C238.991 357.066 239.972 356.772 240.344 355.581",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.315 357.372C240.315 357.372 241.298 357.074 241.665 355.886",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M247.124 358.809C245.293 358.393 243.46 357.975 241.628 357.553C241.742 357.06 241.855 356.567 241.966 356.073C243.795 356.493 245.628 356.911 247.458 357.328C247.348 357.822 247.234 358.315 247.124 358.809Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 241,
    y: 356,
    width: 7,
    height: 3
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M247.124 358.809C245.293 358.393 243.46 357.974 241.628 357.553C241.742 357.06 241.855 356.567 241.966 356.073C243.795 356.493 245.628 356.911 247.459 357.328C247.348 357.822 247.234 358.315 247.124 358.809Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.837 357.723C241.837 357.723 242.82 357.426 243.187 356.237",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.163 358.025C243.163 358.025 244.146 357.727 244.513 356.539",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.484 358.329C244.484 358.329 245.464 358.03 245.831 356.841",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.81 358.631C245.81 358.631 246.79 358.332 247.158 357.14",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M252.622 360.051C250.789 359.641 248.954 359.226 247.124 358.809C247.234 358.315 247.348 357.822 247.459 357.328C249.289 357.744 251.12 358.158 252.953 358.568C252.843 359.062 252.732 359.556 252.622 360.051Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 247,
    y: 357,
    width: 6,
    height: 4
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M252.622 360.051C250.789 359.641 248.954 359.226 247.124 358.809C247.234 358.315 247.348 357.822 247.459 357.327C249.289 357.744 251.12 358.158 252.953 358.568C252.843 359.062 252.732 359.556 252.622 360.051Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.334 358.976C247.334 358.976 248.314 358.677 248.679 357.483",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.657 359.276C248.657 359.276 249.637 358.976 250.002 357.783",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.984 359.574C249.984 359.574 250.964 359.275 251.329 358.082",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.306 359.875C251.306 359.875 252.288 359.573 252.651 358.383",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M258.122 361.277C256.288 360.871 254.455 360.461 252.622 360.051C252.733 359.556 252.843 359.062 252.954 358.568C254.787 358.977 256.62 359.387 258.451 359.793C258.34 360.287 258.233 360.783 258.122 361.277Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 252,
    y: 358,
    width: 7,
    height: 4
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M258.123 361.277C256.288 360.87 254.455 360.46 252.622 360.05C252.733 359.556 252.843 359.062 252.954 358.567C254.787 358.977 256.62 359.387 258.451 359.793C258.34 360.287 258.233 360.783 258.123 361.277Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.833 360.217C252.833 360.217 253.814 359.914 254.174 358.723",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.157 360.514C254.157 360.514 255.138 360.211 255.498 359.02",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.482 360.808C255.482 360.808 256.463 360.505 256.823 359.314",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81 361.102C256.81 361.102 257.788 360.798 258.15 359.604",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M263.628 362.49C261.793 362.086 259.957 361.683 258.123 361.276C258.233 360.782 258.34 360.286 258.451 359.792C260.285 360.199 262.117 360.6 263.953 361.004C263.846 361.499 263.736 361.994 263.63 362.486L263.628 362.49Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 258,
    y: 359,
    width: 6,
    height: 4
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M263.629 362.489C261.793 362.086 259.957 361.683 258.123 361.276C258.233 360.782 258.34 360.286 258.451 359.792C260.285 360.199 262.118 360.6 263.953 361.004C263.846 361.499 263.736 361.994 263.63 362.486L263.629 362.489Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.333 361.443C258.333 361.443 259.311 361.139 259.673 359.945",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.663 361.734C259.663 361.734 260.642 361.427 261.003 360.236",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.988 362.028C260.988 362.028 261.968 361.721 262.325 360.528",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.315 362.319C262.315 362.319 263.294 362.012 263.651 360.819",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M269.137 363.687C267.298 363.291 265.464 362.892 263.629 362.489C263.736 361.993 263.846 361.499 263.952 361.007C265.784 361.408 267.622 361.808 269.457 362.203C269.35 362.699 269.244 363.192 269.137 363.687Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 263,
    y: 361,
    width: 7,
    height: 3
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M269.137 363.687C267.298 363.291 265.464 362.892 263.629 362.489C263.736 361.993 263.846 361.499 263.952 361.006C265.784 361.408 267.622 361.808 269.457 362.203C269.35 362.699 269.244 363.192 269.137 363.687Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.839 362.656C263.839 362.656 264.819 362.349 265.172 361.155",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.167 362.943C265.167 362.943 266.147 362.636 266.5 361.442",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.494 363.233C266.494 363.233 267.473 362.926 267.827 361.732",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.822 363.52C267.822 363.52 268.798 363.211 269.151 362.018",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M274.647 364.871C272.811 364.479 270.972 364.083 269.137 363.687C269.244 363.192 269.35 362.699 269.457 362.204C271.292 362.599 273.127 362.994 274.964 363.386C274.857 363.881 274.754 364.375 274.647 364.871Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 269,
    y: 362,
    width: 6,
    height: 3
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M274.647 364.871C272.811 364.479 270.972 364.083 269.137 363.687C269.244 363.192 269.35 362.699 269.457 362.204C271.292 362.599 273.127 362.994 274.964 363.386C274.857 363.881 274.754 364.375 274.647 364.871Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.349 363.851C269.349 363.851 270.326 363.539 270.68 362.345",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.677 364.138C270.677 364.138 271.654 363.826 272.008 362.632",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.005 364.425C272.005 364.425 272.982 364.113 273.332 362.917",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.331 364.707C273.331 364.707 274.308 364.395 274.659 363.2",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M280.163 366.041C278.325 365.652 276.487 365.264 274.651 364.872C274.758 364.376 274.86 363.883 274.967 363.387C276.804 363.779 278.641 364.171 280.477 364.554C280.373 365.051 280.267 365.544 280.163 366.041Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 274,
    y: 363,
    width: 7,
    height: 4
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M280.163 366.041C278.325 365.652 276.487 365.264 274.651 364.872C274.758 364.376 274.86 363.883 274.967 363.387C276.804 363.779 278.641 364.171 280.477 364.554C280.373 365.051 280.267 365.544 280.163 366.041Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.859 365.034C274.859 365.034 275.837 364.722 276.187 363.527",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.189 365.317C276.189 365.317 277.166 365.005 277.513 363.809",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.515 365.6C277.515 365.6 278.492 365.288 278.839 364.091",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.844 365.884C278.844 365.884 279.818 365.57 280.169 364.375",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M285.677 367.197C283.836 366.815 281.998 366.427 280.159 366.042C280.262 365.545 280.368 365.052 280.472 364.555C282.31 364.944 284.146 365.327 285.985 365.712C285.882 366.209 285.779 366.703 285.675 367.2L285.677 367.197Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 280,
    y: 364,
    width: 6,
    height: 4
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M285.677 367.197C283.836 366.815 281.998 366.427 280.159 366.042C280.263 365.545 280.368 365.052 280.472 364.555C282.31 364.944 284.146 365.327 285.986 365.712C285.882 366.21 285.779 366.703 285.676 367.2L285.677 367.197Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.376 366.203C280.376 366.203 281.351 365.886 281.698 364.689",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.703 366.482C281.703 366.482 282.678 366.165 283.025 364.968",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.03 366.76C283.03 366.76 284.006 366.443 284.353 365.247",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.361 367.04C284.361 367.04 285.337 366.724 285.68 365.526",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M291.197 368.338C289.359 367.961 287.518 367.579 285.677 367.197C285.781 366.7 285.883 366.206 285.987 365.709C287.823 366.093 289.665 366.471 291.503 366.852C291.4 367.345 291.3 367.844 291.197 368.338Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 285,
    y: 365,
    width: 7,
    height: 4
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M291.197 368.338C289.359 367.961 287.518 367.579 285.677 367.197C285.781 366.7 285.883 366.206 285.987 365.709C287.823 366.093 289.665 366.471 291.503 366.852C291.4 367.345 291.3 367.844 291.197 368.338Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.893 367.362C285.893 367.362 286.868 367.045 287.211 365.847",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.221 367.637C287.221 367.637 288.197 367.32 288.54 366.122",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.551 367.91C288.551 367.91 289.527 367.593 289.867 366.393",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.88 368.185C289.88 368.185 290.857 367.865 291.196 366.669",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M296.72 369.462C294.88 369.089 293.036 368.714 291.198 368.337C291.301 367.84 291.4 367.344 291.503 366.851C293.342 367.228 295.18 367.605 297.021 367.978C296.922 368.473 296.818 368.97 296.719 369.466L296.72 369.462Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 291,
    y: 366,
    width: 7,
    height: 4
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M296.72 369.462C294.88 369.089 293.037 368.714 291.198 368.337C291.301 367.84 291.4 367.344 291.503 366.851C293.342 367.228 295.181 367.605 297.021 367.978C296.922 368.473 296.818 368.97 296.719 369.466L296.72 369.462Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.41 368.5C291.41 368.5 292.383 368.179 292.725 366.984",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.74 368.772C292.74 368.772 293.713 368.451 294.054 367.251",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.07 369.045C294.07 369.045 295.044 368.723 295.384 367.524",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.402 369.313C295.402 369.313 296.375 368.992 296.715 367.792",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M302.247 370.578C300.406 370.208 298.564 369.838 296.724 369.464C296.823 368.969 296.927 368.472 297.026 367.976C298.866 368.35 300.707 368.72 302.546 369.089C302.447 369.584 302.346 370.083 302.247 370.578Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 296,
    y: 367,
    width: 7,
    height: 4
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M302.247 370.578C300.406 370.208 298.564 369.837 296.724 369.464C296.823 368.969 296.927 368.472 297.026 367.976C298.866 368.35 300.708 368.72 302.546 369.089C302.447 369.584 302.346 370.083 302.247 370.578Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.936 369.627C296.936 369.627 297.909 369.305 298.246 368.104",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.264 369.894C298.264 369.894 299.237 369.573 299.574 368.372",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.596 370.163C299.596 370.163 300.57 369.838 300.906 368.641",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.927 370.432C300.927 370.432 301.902 370.107 302.234 368.908",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M307.773 371.676C305.929 371.313 304.086 370.946 302.244 370.576C302.343 370.08 302.444 369.582 302.543 369.087C304.384 369.457 306.224 369.822 308.068 370.186C307.969 370.681 307.872 371.181 307.773 371.676Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 302,
    y: 369,
    width: 7,
    height: 3
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M307.773 371.676C305.929 371.312 304.086 370.946 302.244 370.575C302.343 370.08 302.444 369.582 302.543 369.087C304.384 369.457 306.224 369.822 308.068 370.186C307.969 370.681 307.872 371.181 307.773 371.676Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.461 370.736C302.461 370.736 303.436 370.411 303.768 369.212",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.792 371.005C303.792 371.005 304.764 370.679 305.099 369.481",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.122 371.269C305.122 371.269 306.093 370.943 306.425 369.744",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.457 371.532C306.457 371.532 307.428 371.205 307.761 370.003",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M313.306 372.758C311.463 372.399 309.618 372.039 307.775 371.672C307.874 371.177 307.971 370.677 308.07 370.182C309.911 370.544 311.755 370.908 313.598 371.266C313.502 371.763 313.406 372.26 313.306 372.758Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 307,
    y: 370,
    width: 7,
    height: 3
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M313.306 372.758C311.463 372.399 309.618 372.039 307.775 371.672C307.874 371.177 307.971 370.677 308.07 370.182C309.911 370.544 311.755 370.908 313.598 371.266C313.502 371.763 313.406 372.259 313.306 372.758Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.99 371.837C307.99 371.837 308.961 371.511 309.295 370.309",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.321 372.098C309.321 372.098 310.293 371.772 310.623 370.568",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.652 372.359C310.652 372.359 311.625 372.029 311.954 370.829",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.987 372.62C311.987 372.62 312.959 372.291 313.288 371.09",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M318.839 373.829C316.996 373.474 315.152 373.119 313.306 372.759C313.402 372.262 313.497 371.765 313.598 371.267C315.44 371.626 317.284 371.981 319.128 372.336C319.032 372.833 318.936 373.329 318.841 373.826L318.839 373.829Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 313,
    y: 371,
    width: 7,
    height: 3
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M318.84 373.829C316.996 373.474 315.152 373.119 313.306 372.758C313.402 372.262 313.497 371.765 313.598 371.267C315.44 371.626 317.284 371.981 319.128 372.336C319.032 372.833 318.937 373.329 318.841 373.826L318.84 373.829Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.519 372.917C313.519 372.917 314.489 372.586 314.818 371.386",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.854 373.18C314.854 373.18 315.823 372.849 316.152 371.649",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.186 373.437C316.186 373.437 317.156 373.106 317.484 371.905",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.519 373.695C317.519 373.695 318.488 373.364 318.814 372.162",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M324.375 374.885C322.529 374.536 320.683 374.184 318.84 373.829C318.935 373.332 319.031 372.835 319.127 372.339C320.97 372.694 322.812 373.045 324.659 373.393C324.567 373.891 324.471 374.388 324.375 374.885Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 318,
    y: 372,
    width: 7,
    height: 3
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M324.375 374.885C322.529 374.536 320.683 374.184 318.84 373.828C318.935 373.332 319.031 372.835 319.127 372.339C320.97 372.694 322.812 373.045 324.659 373.394C324.567 373.891 324.471 374.388 324.375 374.885Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.053 373.988C319.053 373.988 320.023 373.657 320.349 372.452",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.387 374.242C320.387 374.242 321.358 373.908 321.683 372.706",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.721 374.496C321.721 374.496 322.692 374.161 323.014 372.958",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.055 374.75C323.055 374.75 324.026 374.415 324.347 373.212",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M329.913 375.926C328.065 375.58 326.222 375.233 324.376 374.884C324.468 374.387 324.563 373.89 324.659 373.393C326.506 373.742 328.349 374.089 330.194 374.433L329.917 375.927L329.913 375.926Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 324,
    y: 373,
    width: 7,
    height: 3
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M329.914 375.926C328.066 375.58 326.222 375.233 324.376 374.884C324.468 374.386 324.564 373.89 324.659 373.393C326.506 373.742 328.349 374.089 330.194 374.433L329.917 375.927L329.914 375.926Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.592 375.046C324.592 375.046 325.56 374.71 325.885 373.508",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.924 375.295C325.924 375.295 326.892 374.959 327.214 373.756",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.26 375.546C327.26 375.546 328.227 375.21 328.549 374.007",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.595 375.796C328.595 375.796 329.562 375.46 329.884 374.257",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M335.457 376.953C333.611 376.612 331.762 376.27 329.914 375.925L330.19 374.431C332.035 374.775 333.881 375.116 335.727 375.456C335.635 375.954 335.543 376.452 335.454 376.951L335.457 376.953Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 329,
    y: 374,
    width: 7,
    height: 3
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M335.457 376.953C333.611 376.612 331.762 376.27 329.914 375.925L330.19 374.431C332.035 374.775 333.881 375.116 335.727 375.456C335.635 375.954 335.543 376.452 335.454 376.951L335.457 376.953Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.132 376.083C330.132 376.083 331.101 375.744 331.418 374.542",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.467 376.333C331.467 376.333 332.436 375.994 332.754 374.79",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.8 376.579C332.8 376.579 333.769 376.24 334.088 375.036",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.137 376.826C334.137 376.826 335.106 376.487 335.421 375.281",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M340.999 377.964C339.151 377.63 337.303 377.293 335.454 376.951C335.546 376.453 335.638 375.955 335.727 375.455C337.573 375.796 339.421 376.133 341.27 376.467C341.181 376.966 341.088 377.464 340.999 377.964Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 375,
    width: 7,
    height: 3
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M341 377.964C339.151 377.63 337.303 377.293 335.454 376.951C335.546 376.453 335.638 375.955 335.727 375.455C337.573 375.796 339.421 376.133 341.27 376.467C341.181 376.966 341.089 377.464 341 377.964Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.672 377.109C335.672 377.109 336.641 376.769 336.956 375.564",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.009 377.356C337.009 377.356 337.978 377.017 338.289 375.809",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.343 377.598C338.343 377.598 339.309 377.257 339.624 376.051",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.681 377.842C339.681 377.842 340.647 377.501 340.962 376.296",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M346.548 378.962C344.697 378.631 342.848 378.297 341 377.964C341.089 377.464 341.181 376.966 341.27 376.467C343.119 376.801 344.964 377.133 346.814 377.463C346.725 377.963 346.636 378.462 346.549 378.958L346.548 378.962Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 340,
    y: 376,
    width: 7,
    height: 3
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M346.548 378.962C344.697 378.631 342.849 378.297 341 377.963C341.089 377.464 341.181 376.966 341.27 376.467C343.119 376.801 344.964 377.133 346.815 377.464C346.726 377.963 346.637 378.462 346.549 378.958L346.548 378.962Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.218 378.121C341.218 378.121 342.185 377.777 342.495 376.573",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.553 378.364C342.553 378.364 343.519 378.02 343.83 376.816",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.892 378.604C343.892 378.604 344.859 378.26 345.171 377.053",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.228 378.843C345.228 378.843 346.195 378.5 346.503 377.291",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M352.096 379.948C350.248 379.622 348.397 379.295 346.546 378.965C346.635 378.466 346.724 377.966 346.812 377.47C348.659 377.799 350.509 378.13 352.357 378.455C352.268 378.955 352.181 379.451 352.095 379.951L352.096 379.948Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 346,
    y: 377,
    width: 7,
    height: 3
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M352.097 379.948C350.248 379.622 348.397 379.295 346.546 378.965C346.635 378.465 346.724 377.966 346.812 377.47C348.659 377.799 350.509 378.13 352.357 378.455C352.268 378.955 352.181 379.451 352.095 379.951L352.097 379.948Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.766 379.119C346.766 379.119 347.733 378.775 348.041 377.566",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.102 379.358C348.102 379.358 349.066 379.013 349.377 377.805",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.44 379.594C349.44 379.594 350.403 379.249 350.712 378.04",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.777 379.83C350.777 379.83 351.742 379.481 352.049 378.276",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M357.649 380.916C355.798 380.597 353.946 380.27 352.097 379.948C352.186 379.448 352.273 378.952 352.359 378.451C354.207 378.777 356.057 379.099 357.906 379.422C357.821 379.922 357.733 380.418 357.648 380.919L357.649 380.916Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 378,
    width: 6,
    height: 3
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M357.649 380.916C355.798 380.597 353.946 380.27 352.097 379.947C352.186 379.448 352.273 378.952 352.359 378.451C354.207 378.777 356.057 379.099 357.906 379.422C357.821 379.922 357.733 380.418 357.648 380.919L357.649 380.916Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.316 380.101C352.316 380.101 353.281 379.753 353.588 378.547",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.654 380.338C353.654 380.338 354.619 379.989 354.923 378.782",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.993 380.57C354.993 380.57 355.958 380.221 356.261 379.015",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.327 380.804C356.327 380.804 357.292 380.456 357.595 379.249",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M363.204 381.869C361.351 381.553 359.5 381.234 357.649 380.916C357.735 380.415 357.822 379.919 357.908 379.418C359.757 379.74 361.61 380.056 363.458 380.373C363.372 380.874 363.288 381.372 363.202 381.872L363.204 381.869Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 357,
    y: 379,
    width: 7,
    height: 3
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M363.204 381.869C361.351 381.553 359.5 381.234 357.649 380.915C357.735 380.415 357.822 379.919 357.908 379.418C359.758 379.74 361.61 380.056 363.458 380.373C363.372 380.874 363.288 381.372 363.202 381.872L363.204 381.869Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.869 381.07C357.869 381.07 358.834 380.722 359.136 379.51",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.208 381.303C359.208 381.303 360.169 380.953 360.474 379.743",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.543 381.533C360.543 381.533 361.505 381.183 361.81 379.973",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.883 381.763C361.883 381.763 362.846 381.409 363.147 380.201",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M368.763 382.812C366.909 382.5 365.058 382.189 363.207 381.87C363.293 381.369 363.377 380.872 363.463 380.371C365.315 380.686 367.164 381.001 369.015 381.311C368.93 381.809 368.848 382.311 368.764 382.808L368.763 382.812Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 363,
    y: 380,
    width: 7,
    height: 3
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M368.763 382.812C366.909 382.499 365.058 382.189 363.207 381.87C363.293 381.369 363.377 380.872 363.463 380.371C365.315 380.686 367.164 381.001 369.015 381.311C368.931 381.809 368.848 382.311 368.764 382.808L368.763 382.812Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.422 382.026C363.422 382.026 364.385 381.673 364.685 380.465",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.762 382.256C364.762 382.256 365.725 381.903 366.026 380.694",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.101 382.48C366.101 382.48 367.064 382.126 367.361 380.917",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.437 382.708C367.437 382.708 368.4 382.355 368.697 381.145",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M374.32 383.738C372.468 383.431 370.613 383.122 368.763 382.811C368.847 382.314 368.929 381.811 369.013 381.314C370.864 381.625 372.716 381.932 374.568 382.24C374.487 382.739 374.401 383.239 374.32 383.738Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 368,
    y: 381,
    width: 7,
    height: 3
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M374.321 383.738C372.469 383.431 370.613 383.122 368.763 382.811C368.847 382.313 368.929 381.811 369.013 381.314C370.864 381.625 372.716 381.932 374.568 382.24C374.487 382.739 374.401 383.239 374.321 383.738Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.983 382.966C368.983 382.966 369.945 382.613 370.242 381.403",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.321 383.191C370.321 383.191 371.284 382.837 371.577 381.626",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.659 383.415C371.659 383.415 372.62 383.056 372.917 381.847",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.999 383.635C372.999 383.635 373.96 383.277 374.257 382.068",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M379.885 384.649C378.03 384.348 376.177 384.044 374.322 383.735C374.403 383.236 374.488 382.735 374.569 382.237C376.421 382.544 378.274 382.848 380.126 383.148C380.045 383.646 379.963 384.148 379.882 384.647L379.885 384.649Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 374,
    y: 382,
    width: 7,
    height: 3
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M379.885 384.649C378.031 384.348 376.177 384.044 374.322 383.735C374.403 383.236 374.488 382.735 374.569 382.237C376.421 382.544 378.274 382.848 380.126 383.148C380.045 383.646 379.963 384.148 379.882 384.647L379.885 384.649Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.54 383.893C374.54 383.893 375.501 383.535 375.795 382.324",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M59.349 305.316C52.724 314.171 46.0546 323 39.3395 331.806C31.3792 342.244 23.3524 352.643 15.2631 363.011C15.0583 349.862 14.9279 336.725 14.8669 323.6C14.8146 312.525 14.8184 301.458 14.87 290.399C29.6483 295.531 44.4759 300.507 59.3524 305.317L59.349 305.316Z",
    fill: "#F3F4F5"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3487 305.317C53.1848 313.555 46.9819 321.773 40.7367 329.97C32.0924 327.131 23.467 324.237 14.8525 321.288C14.8119 310.983 14.8159 300.685 14.863 290.397C29.6413 295.53 44.4689 300.505 59.3454 305.316L59.3487 305.317Z",
    fill: "#265CA9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M35.817 301.712C35.8097 302.794 35.8039 303.872 35.8001 304.955C36.8385 305.303 37.8736 305.65 38.9134 305.995C37.8731 306.316 36.8328 306.637 35.7924 306.959C35.7866 308.037 35.7828 309.119 35.7803 310.199C35.1404 309.318 34.5018 308.434 33.8633 307.55C32.8196 307.87 31.7806 308.188 30.7369 308.508C31.3832 307.644 32.0342 306.779 32.6805 305.915C32.0419 305.031 31.4068 304.148 30.7716 303.266C31.8086 303.617 32.8437 303.964 33.8821 304.312C34.5284 303.449 35.176 302.582 35.8223 301.719L35.817 301.712Z",
    fill: "#F3F4F5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6974 305.329C46.6983 306.41 46.6958 307.49 46.6967 308.57C47.7346 308.911 48.7758 309.252 49.8137 309.592C48.7753 309.918 47.737 310.244 46.6972 310.574C46.6981 311.655 46.699 312.735 46.6999 313.816C46.0552 312.937 45.4105 312.059 44.7706 311.178C43.7322 311.504 42.6905 311.829 41.6502 312.15C42.2945 311.282 42.9387 310.414 43.5797 309.544C42.9397 308.663 42.2984 307.786 41.6551 306.904C42.6916 307.247 43.7314 307.592 44.7679 307.935C45.4121 307.067 46.0531 306.198 46.694 305.328L46.6974 305.329Z",
    fill: "#F3F4F5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M24.957 298.036C24.9465 299.116 24.9325 300.195 24.9219 301.275C25.959 301.626 26.9912 301.98 28.0283 302.332C26.986 302.648 25.9437 302.965 24.9028 303.278C24.8922 304.358 24.8816 305.438 24.8744 306.519C24.2406 305.633 23.6035 304.746 22.9697 303.86C21.9254 304.171 20.8831 304.488 19.8389 304.8C20.4918 303.939 21.1448 303.079 21.7978 302.218C21.164 301.332 20.535 300.444 19.9012 299.558C20.9369 299.913 21.9691 300.266 23.0048 300.621C23.6578 299.76 24.3074 298.898 24.957 298.036Z",
    fill: "#F3F4F5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8764 313.699C37.8739 314.778 37.8748 315.859 37.871 316.942C38.9142 317.288 39.9574 317.634 41.002 317.977C39.9602 318.302 38.9166 318.622 37.8715 318.945C37.8724 320.026 37.8699 321.106 37.8708 322.186C37.2241 321.303 36.5794 320.424 35.9328 319.54C34.8891 319.86 33.8406 320.182 32.7969 320.502C33.4446 319.635 34.0908 318.772 34.7385 317.905C34.0952 317.023 33.4533 316.137 32.81 315.255C33.8518 315.605 34.895 315.951 35.9368 316.301C36.5844 315.434 37.2273 314.569 37.875 313.702L37.8764 313.699Z",
    fill: "#F3F4F5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9486 310.035C26.9413 311.116 26.9341 312.198 26.9283 313.276C27.9687 313.629 29.0105 313.978 30.0523 314.328C29.0086 314.648 27.963 314.963 26.9173 315.278C26.9101 316.36 26.9076 317.439 26.9004 318.521C26.2585 317.635 25.6166 316.75 24.9781 315.865C23.9324 316.181 22.8834 316.494 21.8377 316.81C22.4907 315.949 23.1417 315.083 23.7947 314.223C23.1575 313.335 22.5156 312.45 21.8785 311.562C22.9189 311.915 23.9593 312.268 24.9997 312.621C25.6493 311.759 26.3003 310.894 26.95 310.032L26.9486 310.035Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 290,
    width: 46,
    height: 74
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M59.349 305.317C52.724 314.172 46.0547 323 39.3397 331.806C31.3794 342.244 23.3527 352.643 15.2634 363.011C15.0585 349.862 14.9278 336.724 14.8667 323.6C14.8142 312.525 14.8178 301.458 14.8693 290.399C29.6478 295.532 44.4756 300.507 59.3523 305.318L59.349 305.317Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27015 360.312C5.49707 359.711 3.72203 359.104 1.94698 358.497C6.19875 346.078 10.4519 333.656 14.7037 321.237C16.4471 321.834 18.1885 322.427 19.9333 323.021C15.7118 335.453 11.4902 347.884 7.26875 360.316L7.27015 360.312Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5955 362.113C10.821 361.514 9.04319 360.915 7.27011 360.313C11.4916 347.881 15.7131 335.45 19.9346 323.018C21.676 323.611 23.4222 324.201 25.1664 324.787C20.9766 337.228 16.7867 349.669 12.5955 362.113Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.925 363.903C16.1478 363.311 14.3733 362.712 12.594 362.116C16.7839 349.675 20.9737 337.234 25.1649 324.79C26.9091 325.376 28.6567 325.963 30.4023 326.546C26.2427 338.999 22.0846 351.449 17.925 363.903Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2582 365.676C21.4795 365.087 19.7023 364.495 17.925 363.903C22.0846 351.45 26.2427 339 30.4023 326.547C32.1479 327.129 33.8935 327.712 35.6419 328.288C31.514 340.75 27.3861 353.213 23.2582 365.676Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5955 367.437C26.8155 366.852 25.0354 366.267 23.2581 365.675C27.386 353.212 31.5139 340.75 35.6418 328.287C37.3888 328.867 39.1372 329.442 40.8856 330.018C36.7894 342.49 32.6917 354.965 28.5955 367.437Z",
    fill: "#CD2027"
  }))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M123.804 325.071C117.459 334.125 111.067 343.159 104.63 352.168C97.0004 362.845 89.3045 373.492 81.5428 384.107C80.9375 370.973 80.4011 357.844 79.9375 344.73C79.5463 333.664 79.209 322.602 78.9231 311.548C93.8386 316.217 108.802 320.725 123.804 325.071Z",
    fill: "#F3F4F5"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M123.804 325.071C117.901 333.497 111.958 341.905 105.974 350.289C97.2542 347.718 88.5502 345.099 79.8599 342.419C79.5047 332.122 79.1906 321.83 78.9245 311.545C93.84 316.214 108.803 320.722 123.805 325.068L123.804 325.071Z",
    fill: "#265CA9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M100.196 322.201C100.221 323.28 100.25 324.36 100.279 325.441C101.323 325.756 102.372 326.069 103.418 326.381C102.388 326.734 101.361 327.089 100.331 327.442C100.36 328.523 100.388 329.603 100.417 330.684C99.7492 329.823 99.086 328.96 98.4195 328.096C97.3896 328.449 96.3577 328.798 95.3244 329.149C95.9446 328.263 96.5667 327.382 97.1869 326.496C96.5237 325.633 95.8605 324.77 95.1974 323.907C96.245 324.224 97.2879 324.543 98.3355 324.859C98.9557 323.973 99.5745 323.09 100.195 322.204L100.196 322.201Z",
    fill: "#F3F4F5"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M111.175 325.476C111.208 326.554 111.24 327.636 111.274 328.715C112.321 329.023 113.368 329.331 114.418 329.641C113.394 330.001 112.366 330.359 111.338 330.717C111.371 331.795 111.408 332.875 111.44 333.957C110.771 333.1 110.098 332.241 109.43 331.38C108.402 331.738 107.371 332.095 106.344 332.449C106.961 331.562 107.578 330.674 108.191 329.785C107.523 328.924 106.857 328.068 106.189 327.207C107.235 327.519 108.286 327.829 109.331 328.141C109.948 327.253 110.561 326.364 111.175 325.476Z",
    fill: "#F3F4F5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2342 318.864C89.2547 319.945 89.2767 321.023 89.2972 322.104C90.3434 322.424 91.3863 322.743 92.4325 323.063C91.4006 323.411 90.3721 323.761 89.3383 324.105C89.3588 325.186 89.3841 326.265 89.4094 327.344C88.7476 326.478 88.0858 325.612 87.4274 324.747C86.3955 325.095 85.3616 325.439 84.3278 325.783C84.9533 324.903 85.5788 324.023 86.2057 323.14C85.5473 322.275 84.8869 321.405 84.2333 320.539C85.2781 320.862 86.3196 321.184 87.3658 321.504C87.9913 320.624 88.6149 319.739 89.237 318.858L89.2342 318.864Z",
    fill: "#F3F4F5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M102.62 334.117C102.652 335.199 102.682 336.276 102.714 337.358C103.766 337.673 104.82 337.984 105.869 338.297C104.838 338.654 103.804 339.005 102.773 339.362C102.805 340.444 102.838 341.523 102.872 342.601C102.2 341.739 101.528 340.88 100.856 340.018C99.8231 340.37 98.7885 340.725 97.7518 341.075C98.372 340.189 98.9922 339.303 99.6109 338.42C98.9396 337.558 98.2731 336.694 97.6052 335.833C98.6576 336.148 99.7086 336.466 100.761 336.78C101.381 335.894 101.998 335.006 102.617 334.124L102.62 334.117Z",
    fill: "#F3F4F5"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5934 330.794C91.6186 331.873 91.6439 332.952 91.6712 334.036C92.7222 334.354 93.7732 334.672 94.8242 334.99C93.7909 335.342 92.7556 335.689 91.719 336.039C91.7476 337.12 91.7729 338.199 91.8016 339.279C91.1317 338.414 90.4651 337.55 89.8 336.682C88.7647 337.029 87.7295 337.376 86.6909 337.722C87.3164 336.842 87.9399 335.957 88.5654 335.077C87.9003 334.21 87.2338 333.346 86.572 332.479C87.6216 332.801 88.6712 333.122 89.7222 333.44C90.3443 332.559 90.9679 331.674 91.59 330.792L91.5934 330.794Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 311,
    width: 46,
    height: 74
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M123.804 325.071C117.459 334.125 111.067 343.16 104.631 352.168C97.0006 362.846 89.3048 373.492 81.5432 384.107C80.9376 370.973 80.4011 357.844 79.9373 344.73C79.5459 333.664 79.2085 322.602 78.9224 311.548C93.8381 316.218 108.801 320.725 123.804 325.071Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4813 381.66C71.6893 381.113 69.902 380.565 68.1113 380.015C71.9785 367.468 75.8443 354.924 79.7082 342.375C81.4672 342.916 83.2262 343.457 84.9832 343.993C81.1477 356.549 77.3121 369.106 73.4813 381.66Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8554 383.295C77.0653 382.753 75.2718 382.209 73.4812 381.659C77.3167 369.103 81.1523 356.547 84.9831 343.992C86.7435 344.53 88.5005 345.066 90.2637 345.597C86.4598 358.162 82.6559 370.728 78.8554 383.295Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2318 384.916C82.4403 384.377 80.6455 383.837 78.8554 383.295C82.6593 370.73 86.4632 358.164 90.2637 345.597C92.0255 346.131 93.7853 346.661 95.5451 347.19C91.7729 359.765 88.0007 372.339 84.2285 384.914L84.2318 384.916Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6137 386.523C87.8195 385.991 86.0266 385.456 84.2317 384.916C88.0039 372.341 91.7762 359.766 95.5484 347.192C97.3082 347.721 99.0741 348.245 100.835 348.771C97.0948 361.355 93.3543 373.939 89.6137 386.523Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9979 388.114C93.2022 387.586 91.4079 387.054 89.6137 386.522C93.3542 373.938 97.0947 361.355 100.835 348.771C102.598 349.293 104.36 349.816 106.124 350.335C102.416 362.928 98.7068 375.521 94.9979 388.114Z",
    fill: "#CD2027"
  }))), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M188.796 342.809C182.737 352.057 176.631 361.285 170.477 370.489C163.183 381.401 155.822 392.277 148.396 403.127C147.386 390.018 146.449 376.916 145.586 363.821C144.857 352.773 144.181 341.728 143.553 330.69C158.595 334.895 173.677 338.935 188.799 342.81L188.796 342.809Z",
    fill: "#F3F4F5"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M188.796 342.808C183.157 351.414 177.48 360 171.759 368.568C162.968 366.272 154.197 363.92 145.431 361.516C144.757 351.237 144.132 340.961 143.55 330.688C158.591 334.893 173.673 338.933 188.796 342.808Z",
    fill: "#265CA9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M165.124 340.673C165.185 341.751 165.246 342.829 165.304 343.906C166.358 344.189 167.412 344.469 168.467 344.75C167.451 345.136 166.432 345.521 165.417 345.905C165.478 346.983 165.539 348.061 165.604 349.141C164.911 348.301 164.22 347.458 163.532 346.617C162.514 346.999 161.495 347.384 160.476 347.766C161.068 346.864 161.664 345.96 162.255 345.058C161.567 344.216 160.876 343.373 160.188 342.532C161.242 342.815 162.295 343.099 163.352 343.384C163.943 342.481 164.536 341.576 165.127 340.674L165.124 340.673Z",
    fill: "#F3F4F5"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M176.19 343.605C176.256 344.681 176.32 345.761 176.389 346.839C177.446 347.115 178.502 347.392 179.56 347.666C178.545 348.057 177.531 348.448 176.514 348.838C176.58 349.914 176.648 350.995 176.717 352.073C176.019 351.236 175.326 350.399 174.628 349.562C173.611 349.952 172.595 350.338 171.577 350.728C172.166 349.822 172.754 348.918 173.34 348.01C172.648 347.17 171.954 346.334 171.261 345.495C172.316 345.775 173.372 346.052 174.429 346.328C175.015 345.42 175.602 344.517 176.188 343.608L176.19 343.605Z",
    fill: "#F3F4F5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M154.074 337.683C154.127 338.761 154.183 339.842 154.238 340.917C155.29 341.204 156.345 341.492 157.399 341.776C156.381 342.157 155.36 342.534 154.342 342.916C154.399 343.996 154.456 345.073 154.513 346.153C153.826 345.309 153.14 344.464 152.454 343.619C151.434 343.996 150.412 344.376 149.389 344.752C149.987 343.853 150.585 342.954 151.179 342.053C150.493 341.208 149.811 340.361 149.128 339.518C150.179 339.808 151.234 340.096 152.285 340.386C152.88 339.486 153.478 338.587 154.072 337.686L154.074 337.683Z",
    fill: "#F3F4F5"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M167.908 352.51C167.972 353.589 168.038 354.666 168.103 355.745C169.161 356.027 170.224 356.306 171.283 356.585C170.263 356.973 169.243 357.358 168.222 357.747C168.287 358.826 168.356 359.904 168.42 360.984C167.721 360.141 167.024 359.304 166.328 358.463C165.305 358.847 164.285 359.232 163.263 359.616C163.855 358.71 164.447 357.808 165.039 356.903C164.343 356.062 163.647 355.221 162.956 354.378C164.018 354.661 165.076 354.943 166.138 355.225C166.73 354.32 167.318 353.417 167.911 352.511L167.908 352.51Z",
    fill: "#F3F4F5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M156.794 349.53C156.852 350.607 156.912 351.688 156.973 352.767C158.033 353.053 159.09 353.338 160.15 353.624C159.129 354.004 158.106 354.388 157.085 354.769C157.146 355.847 157.205 356.928 157.267 358.007C156.572 357.162 155.878 356.318 155.186 355.475C154.161 355.854 153.14 356.235 152.112 356.612C152.71 355.713 153.306 354.809 153.901 353.908C153.209 353.066 152.52 352.219 151.83 351.373C152.889 351.663 153.949 351.949 155.004 352.237C155.599 351.337 156.195 350.433 156.79 349.532L156.794 349.53Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 330,
    width: 46,
    height: 74
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M188.796 342.809C182.737 352.057 176.632 361.285 170.477 370.489C163.183 381.401 155.822 392.277 148.397 403.127C147.387 390.018 146.449 376.916 145.586 363.821C144.856 352.773 144.181 341.727 143.553 330.69C158.594 334.895 173.676 338.935 188.799 342.811L188.796 342.809Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.266 400.931C138.462 400.442 136.657 399.945 134.851 399.452C138.327 386.794 141.804 374.132 145.279 361.474C147.053 361.961 148.824 362.444 150.598 362.928C147.154 375.596 143.71 388.263 140.265 400.934L140.266 400.931Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.682 402.398C143.877 401.913 142.069 401.423 140.265 400.934C143.709 388.267 147.153 375.599 150.598 362.928C152.373 363.413 154.145 363.892 155.92 364.368C152.507 377.045 149.095 389.722 145.682 402.398Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.106 403.849C149.299 403.367 147.491 402.885 145.684 402.395C149.096 389.718 152.508 377.041 155.921 364.365C157.695 364.841 159.472 365.318 161.248 365.791C157.867 378.477 154.486 391.163 151.106 403.849Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.53 405.288C154.721 404.81 152.913 404.331 151.106 403.849C154.486 391.163 157.867 378.477 161.248 365.791C163.023 366.264 164.798 366.737 166.577 367.203C163.228 379.898 159.88 392.59 156.528 405.283L156.53 405.288Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.959 406.714C160.148 406.242 158.338 405.767 156.53 405.288C159.879 392.593 163.226 379.901 166.579 367.208C168.355 367.677 170.134 368.143 171.912 368.609C168.596 381.31 165.275 394.013 161.959 406.714Z",
    fill: "#CD2027"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M254.27 358.522C248.501 367.953 242.683 377.364 236.817 386.755C229.867 397.885 222.845 408.988 215.76 420.062C214.348 406.991 213.009 393.924 211.743 380.862C210.674 369.843 209.656 358.825 208.692 347.809C223.845 351.544 239.039 355.114 254.27 358.522Z",
    fill: "#F3F4F5"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M254.27 358.522C248.901 367.295 243.494 376.057 238.04 384.798C229.187 382.776 220.349 380.697 211.521 378.567C210.532 368.314 209.591 358.061 208.694 347.815C223.847 351.549 239.041 355.119 254.271 358.527L254.27 358.522Z",
    fill: "#265CA9"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M230.553 357.121C230.647 358.196 230.741 359.272 230.834 360.348C231.898 360.597 232.959 360.844 234.023 361.092C233.019 361.507 232.016 361.927 231.009 362.341C231.102 363.417 231.199 364.494 231.293 365.57C230.576 364.752 229.859 363.934 229.143 363.112C228.138 363.528 227.131 363.941 226.123 364.355C226.687 363.434 227.254 362.514 227.818 361.592C227.102 360.771 226.39 359.951 225.677 359.131C226.74 359.382 227.803 359.634 228.862 359.885C229.426 358.963 229.989 358.042 230.55 357.119L230.553 357.121Z",
    fill: "#F3F4F5"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M241.699 359.708C241.798 360.782 241.898 361.86 241.996 362.934C243.058 363.178 244.125 363.42 245.187 363.664C244.187 364.088 243.185 364.508 242.182 364.928C242.284 366.003 242.382 367.077 242.484 368.153C241.762 367.337 241.044 366.522 240.322 365.705C239.319 366.125 238.314 366.544 237.311 366.964C237.872 366.041 238.429 365.117 238.991 364.191C238.272 363.376 237.555 362.558 236.838 361.74C237.902 361.988 238.964 362.232 240.026 362.475C240.583 361.551 241.143 360.629 241.702 359.701L241.699 359.708Z",
    fill: "#F3F4F5"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M219.421 354.471C219.506 355.548 219.597 356.622 219.685 357.7C220.747 357.955 221.808 358.211 222.871 358.462C221.864 358.873 220.857 359.287 219.85 359.697C219.939 360.775 220.03 361.849 220.118 362.927C219.407 362.104 218.692 361.282 217.981 360.459C216.974 360.869 215.965 361.278 214.955 361.687C215.525 360.769 216.095 359.853 216.662 358.933C215.951 358.11 215.24 357.286 214.533 356.461C215.593 356.719 216.655 356.975 217.716 357.23C218.283 356.31 218.852 355.395 219.419 354.475L219.421 354.471Z",
    fill: "#F3F4F5"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M233.699 368.864C233.796 369.941 233.894 371.015 233.991 372.093C235.06 372.339 236.129 372.586 237.198 372.832C236.192 373.251 235.183 373.668 234.177 374.086C234.276 375.16 234.376 376.239 234.478 377.314C233.753 376.497 233.032 375.677 232.31 374.861C231.301 375.278 230.292 375.695 229.281 376.107C229.845 375.186 230.408 374.265 230.974 373.34C230.253 372.52 229.533 371.701 228.812 370.881C229.88 371.131 230.947 371.381 232.014 371.631C232.578 370.709 233.139 369.787 233.7 368.861L233.699 368.864Z",
    fill: "#F3F4F5"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M222.504 366.232C222.598 367.308 222.687 368.386 222.78 369.462C223.847 369.715 224.913 369.968 225.983 370.22C224.976 370.633 223.965 371.046 222.954 371.458C223.047 372.534 223.141 373.61 223.234 374.686C222.515 373.863 221.796 373.04 221.08 372.218C220.069 372.631 219.06 373.04 218.045 373.451C218.616 372.532 219.183 371.612 219.75 370.692C219.034 369.871 218.317 369.044 217.601 368.223C218.665 368.479 219.735 368.734 220.801 368.987C221.368 368.067 221.935 367.147 222.502 366.227L222.504 366.232Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 208,
    y: 347,
    width: 47,
    height: 74
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M254.27 358.522C248.501 367.954 242.683 377.364 236.817 386.755C229.867 397.885 222.845 408.988 215.761 420.062C214.348 406.991 213.01 393.924 211.743 380.862C210.674 369.843 209.656 358.825 208.691 347.809C223.845 351.544 239.039 355.114 254.27 358.522Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.573 418.118C205.754 417.683 203.936 417.247 202.119 416.809C205.204 404.047 208.283 391.288 211.368 378.526C213.154 378.956 214.939 379.385 216.729 379.813C213.678 392.58 210.625 405.351 207.576 418.12L207.573 418.118Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.031 419.417C211.211 418.985 209.391 418.553 207.571 418.121C210.623 405.354 213.676 392.583 216.724 379.815C218.511 380.241 220.298 380.667 222.086 381.09C219.066 393.866 216.046 406.643 213.026 419.419L213.031 419.417Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.493 420.699C216.67 420.274 214.852 419.846 213.033 419.414C216.053 406.638 219.073 393.861 222.093 381.085C223.881 381.508 225.67 381.927 227.457 382.345C224.47 395.128 221.481 407.913 218.495 420.696L218.493 420.699Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.956 421.969C222.135 421.548 220.312 421.123 218.493 420.699C221.48 407.916 224.468 395.131 227.455 382.348C229.245 382.768 231.033 383.183 232.825 383.595C229.87 396.387 226.914 409.178 223.959 421.97L223.956 421.969Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.424 423.226C227.602 422.809 225.78 422.391 223.956 421.969C226.911 409.178 229.866 396.386 232.822 383.595C234.611 384.006 236.403 384.419 238.192 384.83C235.27 397.628 232.346 410.428 229.421 423.224L229.424 423.226Z",
    fill: "#CD2027"
  }))), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M320.178 372.199C314.704 381.805 309.181 391.389 303.608 400.957C297.004 412.297 290.332 423.613 283.594 434.897C281.778 421.876 280.037 408.858 278.37 395.84C276.962 384.857 275.605 373.876 274.303 362.898C289.562 366.16 304.853 369.257 320.176 372.195L320.178 372.199Z",
    fill: "#F3F4F5"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M320.178 372.199C315.084 381.137 309.949 390.059 304.771 398.963C295.864 397.214 286.966 395.413 278.077 393.553C276.774 383.335 275.515 373.116 274.301 362.901C289.56 366.162 304.852 369.26 320.175 372.198L320.178 372.199Z",
    fill: "#265CA9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M296.436 371.532C296.562 372.606 296.69 373.676 296.816 374.75C297.886 374.965 298.956 375.18 300.026 375.396C299.035 375.844 298.045 376.293 297.056 376.738C297.182 377.811 297.313 378.883 297.439 379.957C296.697 379.16 295.955 378.363 295.217 377.568C294.223 378.015 293.23 378.458 292.238 378.902C292.773 377.965 293.309 377.024 293.844 376.087C293.105 375.291 292.365 374.491 291.628 373.692C292.696 373.911 293.765 374.13 294.835 374.345C295.37 373.408 295.906 372.467 296.438 371.529L296.436 371.532Z",
    fill: "#F3F4F5"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M307.654 373.775C307.785 374.847 307.919 375.92 308.05 376.992C309.122 377.204 310.191 377.411 311.264 377.619C310.275 378.073 309.286 378.526 308.298 378.979C308.432 380.052 308.563 381.124 308.699 382.194C307.951 381.402 307.207 380.609 306.464 379.815C305.472 380.267 304.485 380.717 303.493 381.169C304.025 380.23 304.554 379.287 305.086 378.348C304.343 377.554 303.599 376.761 302.858 375.964C303.929 376.176 304.999 376.391 306.067 376.602C306.595 375.662 307.125 374.719 307.653 373.778L307.654 373.775Z",
    fill: "#F3F4F5"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M285.231 369.231C285.353 370.304 285.471 371.378 285.594 372.45C286.661 372.672 287.73 372.891 288.8 373.114C287.808 373.558 286.815 374.002 285.821 374.441C285.943 375.513 286.065 376.589 286.188 377.661C285.45 376.862 284.711 376.058 283.974 375.26C282.98 375.699 281.984 376.141 280.989 376.58C281.531 375.645 282.069 374.709 282.611 373.775C281.875 372.973 281.143 372.172 280.408 371.37C281.473 371.595 282.544 371.819 283.611 372.041C284.149 371.105 284.691 370.171 285.229 369.235L285.231 369.231Z",
    fill: "#F3F4F5"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M299.941 383.172C300.072 384.244 300.203 385.316 300.332 386.391C301.407 386.604 302.481 386.818 303.56 387.032C302.568 387.484 301.574 387.931 300.578 388.382C300.709 389.453 300.843 390.527 300.978 391.6C300.231 390.805 299.481 390.008 298.735 389.214C297.741 389.661 296.742 390.11 295.745 390.555C296.28 389.618 296.816 388.677 297.348 387.739C296.601 386.944 295.856 386.146 295.114 385.349C296.187 385.566 297.264 385.784 298.339 385.997C298.87 385.058 299.407 384.118 299.938 383.179L299.941 383.172Z",
    fill: "#F3F4F5"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M288.676 380.891C288.802 381.964 288.925 383.037 289.051 384.11C290.126 384.332 291.199 384.549 292.275 384.77C291.277 385.216 290.282 385.658 289.286 386.1C289.412 387.174 289.538 388.248 289.669 389.319C288.924 388.521 288.18 387.72 287.439 386.919C286.443 387.362 285.444 387.803 284.445 388.244C284.983 387.308 285.526 386.37 286.065 385.434C285.324 384.634 284.584 383.833 283.843 383.033C284.919 383.255 285.989 383.478 287.064 383.7C287.603 382.764 288.141 381.828 288.681 380.889L288.676 380.891Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 274,
    y: 362,
    width: 47,
    height: 73
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M320.178 372.2C314.705 381.805 309.181 391.389 303.608 400.957C297.005 412.297 290.332 423.613 283.594 434.897C281.779 421.876 280.037 408.858 278.37 395.84C276.962 384.857 275.605 373.876 274.302 362.898C289.561 366.16 304.853 369.258 320.176 372.195L320.178 372.2Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.354 433.212C273.523 432.835 271.694 432.454 269.861 432.072C272.549 419.221 275.236 406.373 277.924 393.522C279.724 393.898 281.52 394.273 283.319 394.641C280.664 407.498 278.009 420.355 275.354 433.212Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.848 434.341C279.015 433.967 277.183 433.593 275.354 433.212C278.009 420.355 280.664 407.498 283.319 394.641C285.117 395.013 286.916 395.381 288.715 395.749C286.093 408.612 283.47 421.478 280.844 434.34L280.848 434.341Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.343 435.455C284.51 435.084 282.68 434.715 280.847 434.341C283.47 421.478 286.093 408.612 288.718 395.75C290.517 396.119 292.318 396.483 294.12 396.845C291.529 409.717 288.937 422.584 286.347 435.456L286.343 435.455Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.845 436.555C290.012 436.193 288.177 435.825 286.347 435.456C288.937 422.584 291.529 409.717 294.12 396.845C295.922 397.206 297.72 397.566 299.523 397.925C296.963 410.801 294.405 423.679 291.846 436.552L291.845 436.555Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.345 437.639C295.511 437.28 293.678 436.918 291.841 436.554C294.402 423.677 296.959 410.799 299.519 397.926C301.319 398.283 303.122 398.641 304.923 398.994C302.396 411.877 299.871 424.76 297.344 437.643L297.345 437.639Z",
    fill: "#CD2027"
  }))), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M386.476 383.835C381.302 393.604 376.079 403.356 370.804 413.091C364.555 424.63 358.235 436.143 351.844 447.635C349.628 434.676 347.487 421.718 345.417 408.76C343.67 397.826 341.977 386.895 340.336 375.961C355.688 378.753 371.07 381.376 386.476 383.835Z",
    fill: "#F3F4F5"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M386.476 383.835C381.662 392.925 376.803 402.001 371.902 411.063C362.942 409.591 353.995 408.062 345.054 406.48C343.437 396.306 341.863 386.134 340.336 375.961C355.688 378.753 371.07 381.376 386.476 383.835Z",
    fill: "#265CA9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M362.726 383.902C362.886 384.97 363.046 386.038 363.206 387.106C364.282 387.288 365.358 387.471 366.434 387.653C365.458 388.131 364.483 388.61 363.504 389.087C363.664 390.155 363.827 391.224 363.987 392.292C363.22 391.52 362.457 390.746 361.69 389.97C360.711 390.447 359.734 390.921 358.755 391.398C359.261 390.445 359.769 389.488 360.275 388.535C359.512 387.761 358.749 386.987 357.987 386.209C359.061 386.395 360.136 386.581 361.211 386.763C361.717 385.81 362.222 384.852 362.728 383.899L362.726 383.902Z",
    fill: "#F3F4F5"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M374.006 385.797C374.171 386.863 374.334 387.932 374.503 389C375.58 389.179 376.655 389.353 377.734 389.528C376.76 390.012 375.787 390.495 374.81 390.977C374.978 392.044 375.143 393.11 375.311 394.177C374.542 393.409 373.772 392.64 373.003 391.871C372.026 392.353 371.051 392.831 370.074 393.313C370.577 392.358 371.078 391.399 371.577 390.443C370.809 389.671 370.043 388.903 369.276 388.131C370.353 388.31 371.428 388.493 372.504 388.667C373.003 387.711 373.504 386.751 374.003 385.795L374.006 385.797Z",
    fill: "#F3F4F5"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M351.452 381.947C351.603 383.015 351.759 384.085 351.914 385.155C352.987 385.344 354.065 385.532 355.138 385.721C354.16 386.194 353.179 386.667 352.199 387.139C352.354 388.209 352.511 389.275 352.666 390.345C351.904 389.568 351.143 388.79 350.381 388.013C349.4 388.485 348.421 388.954 347.437 389.425C347.95 388.474 348.459 387.523 348.972 386.572C348.213 385.796 347.453 385.015 346.696 384.236C347.773 384.426 348.844 384.619 349.917 384.808C350.427 383.856 350.936 382.904 351.445 381.952L351.452 381.947Z",
    fill: "#F3F4F5"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M366.588 395.431C366.752 396.5 366.917 397.566 367.08 398.636C368.16 398.816 369.241 398.997 370.325 399.178C369.345 399.659 368.365 400.139 367.386 400.616C367.551 401.682 367.717 402.753 367.882 403.819C367.109 403.049 366.338 402.275 365.567 401.502C364.587 401.982 363.605 402.458 362.623 402.933C363.129 401.98 363.633 401.022 364.139 400.069C363.368 399.295 362.6 398.523 361.833 397.748C362.916 397.933 363.996 398.113 365.076 398.297C365.578 397.342 366.086 396.386 366.588 395.431Z",
    fill: "#F3F4F5"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M355.255 393.494C355.415 394.562 355.57 395.632 355.73 396.7C356.811 396.889 357.89 397.072 358.973 397.257C357.991 397.733 357.008 398.209 356.028 398.681C356.188 399.749 356.348 400.817 356.506 401.888C355.737 401.111 354.97 400.336 354.204 399.56C353.218 400.035 352.238 400.507 351.25 400.976C351.759 400.024 352.274 399.071 352.783 398.119C352.017 397.343 351.252 396.564 350.49 395.787C351.571 395.975 352.652 396.164 353.73 396.351C354.239 395.399 354.75 394.444 355.256 393.491L355.255 393.494Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_1754_4703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 340,
    y: 375,
    width: 47,
    height: 73
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M386.476 383.836C381.302 393.604 376.079 403.357 370.804 413.091C364.556 424.63 358.235 436.143 351.845 447.635C349.629 434.676 347.487 421.717 345.417 408.76C343.67 397.826 341.976 386.894 340.335 375.961C355.687 378.753 371.07 381.376 386.476 383.836Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_1754_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.557 446.206C341.715 445.883 339.874 445.56 338.034 445.234C340.323 432.308 342.614 419.379 344.9 406.451C346.707 406.772 348.519 407.09 350.328 407.407C348.071 420.339 345.813 433.274 343.557 446.206Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.083 447.163C347.238 446.847 345.399 446.529 343.557 446.206C345.813 433.274 348.071 420.339 350.328 407.407C352.136 407.724 353.946 408.038 355.757 408.348C353.534 421.286 351.306 434.225 349.083 447.163Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.611 448.105C352.768 447.794 350.924 447.478 349.083 447.163C351.306 434.226 353.534 421.286 355.757 408.348C357.569 408.659 359.377 408.967 361.189 409.274C358.999 422.218 356.804 435.163 354.614 448.107L354.611 448.105Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.143 449.036C358.299 448.728 356.455 448.421 354.614 448.106C356.804 435.162 358.999 422.217 361.189 409.274C363.002 409.58 364.811 409.886 366.622 410.188C364.462 423.136 362.303 436.088 360.143 449.036Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.677 449.954C363.832 449.649 361.986 449.345 360.142 449.037C362.303 436.089 364.462 423.136 366.622 410.188C368.433 410.49 370.245 410.789 372.057 411.088C369.93 424.042 367.801 436.999 365.673 449.952L365.677 449.954Z",
    fill: "#CD2027"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagHighLow);
export default __webpack_public_path__ + "static/media/FlagHighLow.d3f4e22832ac9d5df49df7d0bc66f53b.svg";
export { ForwardRef as ReactComponent };